export const roles = {
  ADMIN: "ROLE_ADMINISTRATOR",
  BO: "ROLE_BUSINESS_OFFICER",
  STAFF: "staff",
  CUSTOMER: "customer",
};
const constances = {
  BASE_URL:"https://sandbox.instabusinessgh.com",
  // BASE_URL: "http://127.0.0.1:8000",
  // BASE_URL: "https://sandbox.instabusinessgh.com",
  AUTH_TOKEN: "access_token",
  USER: "user",
};

export default constances;
